import type {
  HeroArticle as HeroArticleType,
  Image,
  Video as VideoType,
} from "@/generated/sb";
import { HeroArticle as HeroArticleUI } from "@repo/ui-parkmobile/HeroArticle";
import {
  imageStoryblokResolver,
  sectionTitleResolver,
  videoResolver,
} from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";
import Video from "@/components/Video";

interface HeroArticleProps {
  blok: HeroArticleType;
  pageType?: "default" | "article";
}

export default function HeroArticle({ blok, pageType = "default" }: HeroArticleProps) {
  if (!blok) {
    return null;
  }

  const imageBlok = blok.image?.[0] as
    | Image
    | VideoType
    | undefined;

  const isVideo = imageBlok?.component === "video";

  const imageAsset =
    imageBlok?.component === "image"
      ? imageStoryblokResolver(imageBlok)
      : undefined;

  const resolvedVideo =
    isVideo && imageBlok
      ? videoResolver(imageBlok as VideoType)
      : undefined;

  const videoComponent =
    isVideo && imageBlok && resolvedVideo ? (
      <Video
        blok={imageBlok as VideoType}
        aspectRatio={pageType === "article" ? "3/2" : "1/1"}
        borderRadius="var(--radius-radius-sm)"
        imageSpace="fill"
      />
    ) : undefined;

  const sectionTitle = blok.typography
    ? sectionTitleResolver(blok.typography)
    : undefined;

  return (
    <div {...storyblokEditable(blok)}>
      <HeroArticleUI
        sectionTitle={sectionTitle || undefined}
        image={imageAsset || undefined}
        video={videoComponent}
        textAlignment={blok.textAlignment}
        topPadding={blok.topPadding}
        bottomPadding={blok.bottomPadding}
        pageType={pageType}
        id={blok.anchor}
      />
    </div>
  );
}
